import { mapState, mapActions } from 'vuex'
import menuMixin from '../mixin/menu'
import { createMenu } from '../libs/util.menu'
import BScroll from 'better-scroll'
export default {
  mixins: [menuMixin],
  props: {
    collapse: {
      type: Boolean,
      value: true
    }
  },
  render(h) {
    return (
      <div class="menu-side">
        <el-menu
          collapse={this.collapse}
          collapseTransition={false}
          uniqueOpened={true}
          defaultActive={this.defaultActive}
          ref="menu"
          onSelect={this.handleMenuSelect}
        >
          {this.aside.map((menu) => createMenu.call(this, h, menu))}
        </el-menu>
        {this.aside.length === 0 && !this.collapse ? (
          <div
            class="d2-layout-header-aside-menu-empty"
            flex="dir:top main:center cross:center"
          >
            <span>没有侧栏菜单</span>
          </div>
        ) : null}
      </div>
    )
  },
  data() {
    return {
      asideHeight: 300,
      BS: null
    }
  },
  computed: {
    ...mapState('admin/menu', [
      'aside',
      'menuMap'
    ]),
    defaultActive() {
      const menu = this.menuMap[this.$route.meta.funcID]
      return menu ? menu.path : this.$route.path
    }
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    // eslint-disable-next-line no-unused-vars
    collapse(val) {
      this.scrollDestroy()
      this.$nextTick(()=>{
        this.scrollInit()
      })
    },
    '$route.meta.PID': {
      async handler(val) {
        await this.asideLoad(val)
      },
      immediate: true
    },
    // 监听路由 控制侧边栏激活状态
    '$route.meta.funcID': {
      handler(value) {
        const menu = this.menuMap[value]
        const getBtnFunc = menu ? menu.btnFunc || [] : []
        this.$store.dispatch('admin/permission/btnRoleSet', getBtnFunc)
      },
      immediate: true
    }
  },
  mounted() {
    this.scrollInit()
  },
  beforeDestroy() {
    this.scrollDestroy()
  },
  methods: {
    ...mapActions('admin/menu', ['asideLoad']),
    scrollInit() {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        // click: true
        // 如果你愿意可以打开显示滚动条
        // scrollbar: {
        //   fade: true,
        //   interactive: false
        // }
      })
    },
    scrollDestroy() {
      // https://github.com/d2-projects/d2-admin/issues/75
      try {
        this.BS.destroy()
      } catch (e) {
        delete this.BS
        this.BS = null
      }
    }
  }
}
